// project imports
import Loadable from 'components/Loadable';
import Tracker from 'components/Tracker';
import { lazy } from 'react';

// ==============================|| MAIN ROUTING ||============================== //
const SamplePage = Loadable(lazy(() => import('pages/SamplePage')));
const HomePage = Loadable(lazy(() => import('pages/HomePage')));
const BookingPage = Loadable(lazy(() => import('pages/BookingPage')));
const AppointmentPage = Loadable(lazy(() => import('pages/AppointmentPage')));
const SharePage = Loadable(lazy(() => import('pages/SharePage')));
const SignupPage = Loadable(lazy(() => import('pages/SignupPage')));

const MainRoutes = [
    {
        path: '/',
        children: [
            {
                path: '',
                element: (
                    <Tracker ga="view_campaign_page">
                        <HomePage />
                    </Tracker>
                )
            },
            {
                path: 'home',
                element: (
                    <Tracker ga="view_campaign_page">
                        <HomePage />
                    </Tracker>
                )
            },
            {
                path: 'booking',
                element: (
                    <Tracker ga="view_reservation_page">
                        <BookingPage />
                    </Tracker>
                )
            },
            {
                path: 'appointment/:id',
                element: (
                    <Tracker ga="view_reservation_complete_page">
                        <AppointmentPage />
                    </Tracker>
                )
            },
            {
                path: 'share',
                element: (
                    <Tracker ga="view_share_page">
                        <SharePage />
                    </Tracker>
                )
            },
            {
                path: 'signup',
                element: (
                    <Tracker ga="signup">
                        <SignupPage />
                    </Tracker>
                )
            }
        ]
    }
];

export default MainRoutes;
